import React from "react";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";

const LiveUpdates = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Trademark section */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary/10 text-primary text-sm font-semibold rounded-full mb-4">
              <Icon name="Award" size={14} />
              Official Registration
            </span>
            <h2 className="section-heading text-foreground mb-5">
              Trademark Registered{" "}
              <span style={{ color: "#2d5016" }}>Trekking Company</span>
            </h2>
            <p className="text-lg text-text-secondary max-w-3xl mx-auto">
              Trekking in Nepal is more than just a journey — it is a life-changing experience through the Himalayas.{" "}
              <span className="font-semibold text-foreground">Trekking Expert Pvt. Ltd.</span>{" "}
              is a legally registered and trademark-protected trekking company, offering safe, authentic, and professionally guided adventures across Everest, Annapurna, Langtang, and beyond.
            </p>
          </div>

          {/* Trademark certificate card */}
          <div className="relative rounded-3xl overflow-hidden shadow-lg border border-gray-100 bg-white">
            {/* Top accent bar */}
            <div className="h-1.5 bg-gradient-to-r from-primary via-himalayan-blue to-sunrise-gold" />
            <div className="p-6 lg:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Icon name="Shield" size={20} className="text-primary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">Official Trademark Certificate</p>
                  <p className="text-sm text-text-secondary">Government of Nepal · Registered & Protected</p>
                </div>
                <div className="ml-auto flex items-center gap-1.5 px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-semibold">
                  <span className="w-2 h-2 rounded-full bg-green-500" />
                  Verified
                </div>
              </div>
              <img
                src="/assets/images/Trademark.jpeg"
                alt="Trademark Registration - Trekking Expert Pvt. Ltd."
                className="w-full max-h-[500px] object-contain rounded-xl bg-gray-50"
              />
            </div>
          </div>
        </div>

        {/* CTA banner */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary via-primary/95 to-himalayan-blue text-white p-8 lg:p-14">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />

          <div className="relative text-center max-w-2xl mx-auto">
            <div className="w-14 h-14 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Icon name="Compass" size={28} className="text-white" />
            </div>
            <h3 className="font-headline text-2xl sm:text-3xl lg:text-4xl mb-4 text-white" style={{ fontWeight: 300 }}>
              Want to Be Part of the Next{" "}
              <span style={{ color: "#c4873a" }}>Adventure</span>?
            </h3>
            <p className="text-white/85 text-lg mb-8">
              Join our upcoming expeditions and share your own journey with the world. Your adventure story could be the next one inspiring others.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate("/trek-discovery-hub")}
                className="flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-primary font-bold rounded-xl hover:bg-white/90 transition-colors shadow-sm"
              >
                <Icon name="Compass" size={16} />
                View Upcoming Treks
              </button>
              <button
                onClick={() => navigate("/booking-consultation-center")}
                className="flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-white/40 text-white font-semibold rounded-xl hover:bg-white/10 transition-colors"
              >
                <Icon name="Calendar" size={16} />
                Book Consultation
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveUpdates;
